import { User } from './user';

export class AgentGroup {
  agent_group_number!: string;
  registration_number?: string;
  company_name!: string;
  company_industry!: string;
  details?: string;
  contact_person_name?: string;
  contact_person_national_id?: string;
  contact_person_phone_number?: string;
  contact_person_email?: string;
  street_address?: string;
  city?: string;
  country?: string;
  phone_number?: string;
  email?: string;
  logo_path?: string;
  commission_per_individual_member!: number;
  commission_per_corporate_member!: number;
  // Stage 5 PR 57/60, 2026-05-16 — Agent groups are always %-based.
  // These two columns are the ceiling within which a sub-agent's
  // commission is carved (operator-confirmed split rule).
  commission_percentage_for_members?: number;
  commission_percentage_for_companies?: number;
  primary_color!: string;
  tax_certificate_number?: string;
  tax_certificate_exiry_date?: number;
  tax_certificate_path?: string;
  cr14_path?: string;
  registration_certificate_path?: string;
  date_joined?: number;
  date_approved?: number;
  location_latitude?: number;
  location_longitude?: number;
  status!: string;
  date_deleted?: number;
  user_uuid!: string;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;

  isPending() {
    return this.status.toLocaleLowerCase() == 'pending';
  }

  isApproved() {
    return this.status.toLocaleLowerCase() == 'approved';
  }

  isSuspended() {
    return this.status.toLocaleLowerCase() == 'suspended';
  }

  isTerminated() {
    return this.status.toLocaleLowerCase() == 'terminated';
  }

  constructor(data: any) {
    this.agent_group_number = data.agent_group_number;
    this.registration_number = data.registration_number;
    this.company_name = data.company_name;
    this.company_industry = data.company_industry;
    this.details = data.details;
    this.contact_person_name = data.contact_person_name;
    this.contact_person_national_id = data.contact_person_national_id;
    this.contact_person_phone_number = data.contact_person_phone_number;
    this.contact_person_email = data.contact_person_email;
    this.street_address = data.street_address;
    this.city = data.city;
    this.country = data.country;
    this.phone_number = data.phone_number;
    this.email = data.email;
    this.date_joined = data.date_joined;
    this.logo_path = data.logo_path;
    this.commission_per_individual_member = data.commission_per_individual_member;
    this.commission_per_corporate_member = data.commission_per_corporate_member;
    this.commission_percentage_for_members   = data.commission_percentage_for_members;
    this.commission_percentage_for_companies = data.commission_percentage_for_companies;
    this.primary_color = data.primary_color;
    this.tax_certificate_number = data.tax_certificate_number;
    this.tax_certificate_exiry_date = data.tax_certificate_exiry_date;
    this.tax_certificate_path = data.tax_certificate_path;
    this.cr14_path = data.cr14_path;
    this.registration_certificate_path = data.registration_certificate_path;
    this.date_approved = data.date_approved;
    this.location_latitude = data.location_latitude;
    this.location_longitude = data.location_longitude;
    this.status = data.status;
    this.date_deleted = data.date_deleted;
    this.user_uuid = data.user_uuid;
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
  }
}
